<p-dialog [(visible)]="open" header="Print Labels" [modal]="true" [closable]="false" [style]="{ 'min-width': '20rem' }">
  <div *ngIf="loading" class="text-center my-4">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p class="mt-2">Loading printers & labels...</p>
  </div>
  <div *ngIf="printing" class="text-center my-4">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p class="mt-2">Printing labels, please wait...</p>
  </div>
  <div *ngIf="!loading && !printing" class="mt-1">
    <div>
      <p-floatlabel variant="on">
        <p-select
          appLockInitialWidth
          fluid="true"
          [options]="labelOptions()"
          [(ngModel)]="selectedLabel"
          [showClear]="true"
          data-testid="labelTemplate"
          appendTo="body"></p-select>
        <label for="on_label">Label</label>
      </p-floatlabel>
    </div>
    <div class="mt-2">
      <p-floatlabel variant="on">
        <p-select
          appLockInitialWidth
          fluid="true"
          [options]="printerOptions()"
          [(ngModel)]="selectedPrinter"
          [showClear]="true"
          data-testid="labelPrinter"
          appendTo="body"></p-select>
        <label for="on_label">Printer</label>
      </p-floatlabel>
    </div>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        data-testid="cancelPrintLabel"
        (click)="onCancel()" />
      <p-button
        label="Print"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        [disabled]="!selectedLabel || !selectedPrinter || loading"
        [loading]="loading"
        data-testid="printLabel"
        (click)="onPrint()" />
    </div>
  </ng-template>
</p-dialog>
